import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sofi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error?.config?.url || "";
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    // 403 en modo impersonación: aviso amigable + no propagamos toast por handler
    // (el mensaje viene del middleware `enforce_read_only_impersonation`).
    if (status === 403 && typeof detail === "string" && detail.includes("Modo solo lectura")) {
      toast.warning(detail);
    }
    if (status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem("sofi_token");
      // No borramos sofi_admin_token_backup para que al volver a login el usuario
      // no arrastre una impersonación colgada.
      localStorage.removeItem("sofi_admin_token_backup");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const apiErrorMessage = (error, fallback = "Ha ocurrido un error") => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((d) => (typeof d === "string" ? d : d?.msg)).filter(Boolean);
    if (msgs.length) return msgs.join("; ");
  }
  if (detail && typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return error?.message || fallback;
};
